'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = NavItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./nav-item.scss');

var _link = require('../link');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH NavItem Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */

// css
function NavItem(props) {
    var _cx;

    var _props$type = props.type,
        type = _props$type === undefined ? 'default' : _props$type,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$style = props.style,
        style = _props$style === undefined ? 'bare' : _props$style,
        _props$size = props.size,
        size = _props$size === undefined ? 'normal' : _props$size,
        _props$isHollow = props.isHollow,
        isHollow = _props$isHollow === undefined ? false : _props$isHollow,
        _props$isExpanded = props.isExpanded,
        isExpanded = _props$isExpanded === undefined ? false : _props$isExpanded,
        _props$isDark = props.isDark,
        isDark = _props$isDark === undefined ? false : _props$isDark,
        onClick = props.onClick,
        href = props.href,
        title = props.title,
        target = props.target,
        _props$disabled = props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$rel = props.rel,
        rel = _props$rel === undefined ? '' : _props$rel;


    var classNames = type === 'default' ? className : (0, _classnames2.default)((_cx = {
        'sb-btn': true,
        'sb-btn--hollow': isHollow,
        'sb-btn--expanded': isExpanded,
        'sb-btn--dark': isDark
    }, (0, _defineProperty3.default)(_cx, 'sb-btn--' + style, style), (0, _defineProperty3.default)(_cx, 'sb-btn--' + size, size), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    if (href) {
        return (0, _jsx3.default)(_link.Link, {
            className: classNames,
            rel: rel,
            href: href,
            title: title,
            target: target,
            id: id
        }, void 0, props.children);
    }

    return (0, _jsx3.default)('button', {
        className: classNames,
        onClick: onClick,
        title: title,
        disabled: disabled,
        id: id
    }, void 0, props.children);
}
// components
//# sourceMappingURL=NavItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/navItem/NavItem.js
// module id = 273
// module chunks = 0